import * as ElementPlusIconsVue from '@element-plus/icons-vue'

/* common components */
// 原生数据类型扩展
export default {
	install(app) {
		const vueIconNameList = [];
		// 注册全部Icons
		for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
			vueIconNameList.push(key);
			app.component(key, component)
		}
        app.config.globalProperties.iconNameList = vueIconNameList;
    }
}